import { merge } from '../../../../utils/state';
import { TYPES } from './actions';
import entity from './entity';

import ReduxRestEntity from '../../../../utils/reduxRestEntity';

const coreReducer = entity.getReducer();

const INITIAL_STATE = {
  ...ReduxRestEntity.initialState,
  isUpdating: false,
  sponsorships: {
    ...ReduxRestEntity.initialState,
    isUpdating: false,
    isCreating: false,
  },
  sponsorshipsHistory: { ...ReduxRestEntity.initialState },
  pagination: {
    pageSize: 15,
    pageNumber: 1,
    hasMore: false,
    totalElements: 0,
  },
};

const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case TYPES.CREATE_CAMPAIGN_REQUEST:
      return merge(state, {
        isLoading: true,
        error: null,
      });
    case TYPES.CREATE_CAMPAIGN_FAILURE:
      return merge(state, {
        isLoading: false,
        error: action.payload,
      });
    case TYPES.CREATE_CAMPAIGN_SUCCESS:
      return merge(state, {
        isLoading: false,
        error: null,
      });
    case TYPES.GET_CAMPAIGN_REQUEST:
      return merge(state, {
        isLoading: true,
      });
    case TYPES.GET_CAMPAIGN_FAILURE:
      return merge(state, {
        isLoading: false,
        error: action.payload,
      });
    case TYPES.GET_CAMPAIGN_SUCCESS:
      return merge(state, {
        isLoading: false,
        data: merge(state.data, {
          [action.payload.campaign_id]: merge(state.data[action.payload.campaign_id], {
            ...action.payload,
          }),
        }),
        error: null,
      });
    case TYPES.GET_SPONSORSHIPS_REQUEST:
      return merge(state, {
        sponsorships: {
          isLoading: true,
        },
      });
    case TYPES.GET_SPONSORSHIPS_FAILURE:
      return merge(state, {
        sponsorships: {
          isLoading: false,
          error: action.payload,
        },
      });
    case TYPES.GET_SPONSORSHIPS_SUCCESS:
      return merge(state, {
        sponsorships: {
          isLoading: false,
          data: action.payload,
          error: null,
        },
      });
    case TYPES.GET_SPONSORSHIPS_HISTORY_REQUEST:
      return merge(state, {
        sponsorshipsHistory: {
          isLoading: true,
        },
      });
    case TYPES.GET_SPONSORSHIPS_HISTORY_FAILURE:
      return merge(state, {
        sponsorshipsHistory: {
          isLoading: false,
          error: action.payload,
        },
      });
    case TYPES.GET_SPONSORSHIPS_HISTORY_SUCCESS:
      return merge(state, {
        sponsorshipsHistory: {
          isLoading: false,
          data: action.payload,
          error: null,
        },
      });
    case TYPES.GET_CAMPAIGNS_REQUEST:
      if (action.payload?.page === 1) {
        return {
          ...INITIAL_STATE,
          isLoading: true,
        };
      }
      return merge(state, {
        isLoading: true,
      });
    case TYPES.GET_CAMPAIGNS_FAILURE:
      return merge(state, {
        isLoading: false,
        error: action.payload,
      });
    case TYPES.GET_CAMPAIGNS_SUCCESS:
      return merge(state, {
        isLoading: false,
        data: merge(state.data, action.payload.content),
        pagination: merge(state.pagination, {
          pageSize: action.payload.pagination.pageSize,
          pageNumber: action.payload.pagination.pageNumber,
          hasMore: action.payload.pagination.hasMore,
          totalElements: action.payload.pagination.totalElements,
        }),
      });
    case TYPES.CREATE_SPONSORSHIP_REQUEST:
      return merge(state, {
        sponsorships: merge(state.sponsorships, {
          isCreating: true,
          error: null,
        }),
      });
    case TYPES.CREATE_SPONSORSHIP_SUCCESS:
      return merge(state, {
        sponsorships: merge(state.sponsorships, {
          isCreating: false,
          error: null,
        }),
      });
    case TYPES.CREATE_SPONSORSHIP_FAILURE:
      return merge(state, {
        sponsorships: merge(state.sponsorships, {
          isCreating: false,
          error: action.payload,
        }),
      });
    case TYPES.UPDATE_JOB_CAMPAIGN_REQUEST:
      return merge(state, {
        isUpdating: true,
        ...(action?.payload?.data?.campaign_id && { data: merge(state.data, {
          [action?.payload?.data?.campaign_id]: merge(state.data[action?.payload?.data?.campaign_id], {
            isUpdating: true,
          }),
        }) }),
        error: null,
      });
    case TYPES.UPDATE_JOB_CAMPAIGN_ERROR:
      return merge(state, {
        isUpdating: false,
        ...(action?.payload?.campaign_id && { data: merge(state.data, {
          [action?.payload?.data?.campaign_id]: merge(state.data[action?.payload?.data?.campaign_id], {
            isUpdating: false,
          }),
        }) }),
        error: action?.payload?.error,
      });
    case TYPES.UPDATE_JOB_CAMPAIGN_SUCCESS:
      return merge(state, {
        isUpdating: false,
        ...((action?.payload?.shouldUpdateRedux && action?.payload?.data?.campaign_id) && { data: merge(state.data, {
          [action?.payload?.data?.campaign_id]: merge(state.data[action?.payload?.data?.campaign_id], {
            ...action.payload.data,
            isUpdating: false,
          }),
        }),
        }),
        error: null,
      });
    case TYPES.UPDATE_SPONSORSHIP_REQUEST:
      return merge(state, {
        sponsorships: merge(state.sponsorships, {
          isUpdating: true,
          error: null,
        }),
      });
    case TYPES.UPDATE_SPONSORSHIP_SUCCESS:
      return merge(state, {
        sponsorships: merge(state.sponsorships, {
          isUpdating: false,
          error: null,
        }),
      });
    case TYPES.UPDATE_SPONSORSHIP_FAILURE:
      return merge(state, {
        sponsorships: merge(state.sponsorships, {
          isUpdating: false,
          error: action.payload,
        }),
      });
    case TYPES.CLEAR_STATE:
      return INITIAL_STATE;
    case TYPES.CLEAR_SPONSORSHIP_ERROR:
      return merge(state, {
        sponsorships: merge(state.sponsorships, {
          error: {},
        }),
      });
    case TYPES.CLEAR_CAMPAIGN_ERROR:
      return merge(state, {
        error: null,
      });
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
